import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { AuthService } from 'src/app/auth/auth.service';
import { ApplicationBusinessInfo } from '../application.business.info';
import { ApplicationOwnerItem } from '../application.owner.item';
import { environment } from 'src/environments/environment';
import { ApplicationSoleOwnerItem } from '../application.sole.owner.item';
declare var $: any;

@Component({
    selector: 'app-verify-information',
    templateUrl: './verify-information.component.html',
    styleUrls: ['../application.component.css', './verify-information.component.css']
})
export class VerifyInformationComponent implements OnInit {
    @Input() set $appInfo(appInfo: ApplicationBusinessInfo) {
        this.businessInfoForm = appInfo;
    }

    get $appInfo() {
        return this.businessInfoForm;
    }

    @Input() set $ownersInfo(ownersForm: ApplicationOwnerItem) {
        this.ownersInfoForm = ownersForm;
    }

    get $ownersInfo(): ApplicationOwnerItem {
        return this.ownersInfoForm;
    }

    @Input() set $soleOwnersInfo(ownersForm: ApplicationSoleOwnerItem) {
        this.soleOwnersInfoForm = ownersForm;
    }

    get $soleOwnersInfo(): ApplicationSoleOwnerItem {
        return this.soleOwnersInfoForm;
    }

    @Input() statesIssued: any[] = [];
    @Input() token: any;
    @Input() isSole = false;
    @Input() owner: ApplicationSoleOwnerItem;
    @Input() owners: ApplicationOwnerItem;
    @Output() submitClicked = new EventEmitter<any>();
    @Output() backClicked = new EventEmitter<any>();

    @ViewChild('verifyInformationRecaptcha', { static: true }) recaptchaElement: ElementRef;

    ownersInfoCities: any[] = [];
    ownersInfoStates: any[] = [];
    ownersInfoCounties: any[] = [];
    soleOwnersInfoCities: any[] = [];
    soleOwnersInfoStates: any[] = [];
    soleOwnersCounties: any[] = [];
    businessInfoCities: any[] = [];
    businessInfoStates: any[] = [];
    businessInfoCounties: any[] = [];
    captcha: string = '';
    isEditBusiness: boolean = false;
    isEditOwner: boolean = false;
    isSoleOwners: boolean = false;
    businessInfoForm: ApplicationBusinessInfo;
    ownersInfoForm: ApplicationOwnerItem;
    soleOwnersInfoForm: ApplicationSoleOwnerItem;
    businessInfo: ApplicationBusinessInfo = new ApplicationBusinessInfo(this.formBuilder, this.authService);
    ownersInfo: ApplicationOwnerItem = new ApplicationOwnerItem(this.formBuilder);
    soleOwnersInfo: ApplicationSoleOwnerItem = new ApplicationSoleOwnerItem(this.formBuilder, this.authService)
    production: boolean = environment.production;
    submitted: boolean = false;

    get buttonContinueDisabled() {
        return (this.token && !this.captcha);
    }

    constructor(
        private connectionService: ConnectionService,
        private ref: ChangeDetectorRef,
        private authService: AuthService,
        private formBuilder: FormBuilder
    ) {

    }

    ngOnInit(): void {
        if (this.token) {
            this.addRecaptchaScript();
        }
        $('#verifyInformationModal').on('shown.bs.modal', function () {
            if (this.token) {
                try {
                    this.renderReCaptcha();
                } catch (error) {
                    void (0);
                }
            }
        }.bind(this));
    }

    addRecaptchaScript() {
        window['grecaptchaCallback'] = () => {
            this.renderReCaptcha();
        }

        (function (d, s, id, obj) {
            var js: any, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s); js.id = id;
            js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'recaptcha-jssdk', this));
    }

    renderReCaptcha() {
        window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
            'sitekey': '6LeTVW4UAAAAAFLeY2cfpx2fTQ8B0W3-pRdZqh8R ',
            'callback': (response: any) => {
                this.captcha = response;
                this.ref.detectChanges();
            }
        });
    }

    onEditForm(editForm: any) {
        if (editForm === 'isEditBusiness') {
            this.backClicked.emit();
        }
        $("#verifyInformationModal").modal("hide");
        /*this.fillEditForms();
        this[editForm] = !this[editForm];
        if (this.isSole) {
            this.onZipCodeKeyUpHandler('soleOwnersInfo')
        } else {
            editForm === 'isEditBusiness' ? this.onZipCodeKeyUpHandler('businessInfo') : this.onZipCodeKeyUpHandler('ownersInfo');
        }*/
    }

    onDone(editSection: string) {
        if (this.isSole) {
            this.soleOwnersInfoForm.form.setValue(this.soleOwnersInfo.form.getRawValue());
            this[editSection] = !this[editSection];
        } else {
            if (editSection === 'isEditBusiness') {
                this.businessInfoForm.form.setValue(this.businessInfo.form.getRawValue());
                this[editSection] = !this[editSection];

            } else {
                this.ownersInfoForm.form.setValue(this.ownersInfo.form.getRawValue());
                this[editSection] = !this[editSection];
            }
        }
    }

    onZipCodeKeyUpHandler(infoForm: string) {
        this.onZipCodeKeyUp(infoForm).then(
            () => { void (0); },
            () => { void (0); }
        );
    }

    onContinueClick() {
        $("#verifyInformationModal").modal("hide");
        this.submitClicked.emit(this.captcha);
    }

    private onZipCodeKeyUp(infoForm: string) {
        let zipValue = "";
        zipValue = infoForm === 'businessInfo' ? this[infoForm].form.controls.zip.value : this[infoForm].form.controls.zipCode.value;

        return new Promise<void>((resolve, reject) => {
            if (zipValue.length == 5) {
                this.getZipCodeData(zipValue).then(
                    (data: any) => {
                        if (data.object) {
                            this[`${[infoForm]}Cities`] = data.object.city;
                            this[`${[infoForm]}States`] = this.statesIssued;
                            this[`${[infoForm]}Counties`] = data.object.county;

                            this[infoForm].form.controls.city.setValue(data.object.city[0]);
                            this[infoForm].form.controls.state.setValue(data.object.state);

                            if (this[infoForm].form.controls.county) {
                                this[infoForm].form.controls.county.setValue(data.object.county[0]);
                            }

                            resolve(data);
                        } else {
                            this[`${[infoForm]}Cities`] = [];
                            this[`${[infoForm]}Counties`] = [];
                            this[`${[infoForm]}States`] = [];
                            this[infoForm].form.controls.city.setValue('');
                            this[infoForm].form.controls.state.setValue('');

                            if (this[infoForm].form.controls.county) {
                                this[infoForm].form.controls.county.setValue('');
                            }

                            reject();
                        }
                    },
                    (error: any) => {
                        reject();
                    }
                );
            }
        });
    }

    private getZipCodeData(zipCode: string) {
        return new Promise((resolve, reject) => {
            if (this.token) {
                this.connectionService.getRequestWithToken(`${environment.gateway}applicationNl/zipData/${zipCode}`, 'application/json', this.token).subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
            } else {
                this.connectionService.getRequest(`${environment.gateway}application/zipData/${zipCode}`, 'application/json').subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
            }
        });
    }


    private fillEditForms() {
        if (!this.isSole) {
            let tempOwner = this.ownersInfoForm.form.getRawValue();
            let tempBusinness = this.businessInfoForm.form.getRawValue();
            this.businessInfo.form.setValue(tempBusinness);
            this.ownersInfo.form.setValue(tempOwner);
        } else {
            let tempSole = this.soleOwnersInfoForm.form.getRawValue();

            this.soleOwnersInfo.form.controls.businessType.setValue('SoleProprietorship');
            this.soleOwnersInfo.form.controls.ownershipPercentage.setValue(100);
            this.soleOwnersInfo.form.setValue(tempSole);
        }
    }
}
